import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { AddGradeActions } from '../../../../store';
import { TeacherComponent } from ".";
import { TeacherActions } from "../../../../store";
import lodashUtil from 'lodash';
import { gradePickerUtil } from '../../gradePicker';
import { SchoolInformationActions } from "../../../../store"
import { toast } from "react-toastify";
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import { rulesUtil } from "../rules/dialog";
import { saveSchoolConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';
//import theme from '../../../../assests/theme'
class TeacherContainer extends Component {
  constructor(props) {
    super(props);
    let teacher = {
      weeklyAvailability: {},
    }

    this.state = {
      gradeLevelsToBeRendered: {},
      teacher: teacher,
      toggleChange: false,
      teachers: {},
      showAddNewTeacherComponent: false,
      isTeacherPresent: false,
      schedule_constraints: [],
      confirmationDialogTeacher: { isChanged: false },
      isSaved: false
    };
  }
  attachSearchableStringToTeachers = teachers => {
    for (let i = 0; i < teachers.length; i++) {
      let searchableString = []
      searchableString.push(teachers[i].firstName);
      searchableString.push(teachers[i].lastName);
      if (teachers[i].assignedSubjects !== undefined) {
        for (let j = 0; j < teachers[i].assignedSubjects.length; j++) {
          searchableString.push(teachers[i].assignedSubjects[j].subjectName)
          searchableString.push(gradePickerUtil.getGradesDetailedString(teachers[i].assignedSubjects[j].gradeDetails, this.props.activeSchool.school_master.gradeLevels).join(" "))
        }
      }
      teachers[i].searchableString = searchableString.join(" ")
    }
    return teachers;
  }
  onClickOfNewTeacher = () => {
    return {};
  }

  constructTeachersListToBeSend = gradeList => {
    return null;
  };

  onClickOfSave = async (teacher) => {
    const i18n = this.props.i18n
    let tempActiveSchool = this.props.activeSchool;
    if (lodashUtil.isEmpty(tempActiveSchool.school_master) || tempActiveSchool.school_master == undefined) {
      tempActiveSchool.school_master = {};
    }
    if (tempActiveSchool.school_master.teachers.length == 0 || tempActiveSchool.school_master.teachers == undefined) {
      tempActiveSchool.school_master.teachers = []
    }
    if (lodashUtil.find(tempActiveSchool.school_master.teachers, { '_id': teacher._id }) != undefined) {
      tempActiveSchool.school_master.teachers[lodashUtil.findIndex(tempActiveSchool.school_master.teachers, { '_id': teacher._id })] = (teacher)
    } else {
      tempActiveSchool.school_master.teachers.push(teacher)
    }
    tempActiveSchool.school_master.modifiedDate = new Date()
    tempActiveSchool.schedule_constraints = this.state.schedule_constraints

    //await this.props.editSchoolInformation(this.props.userInformation._id, this.props.activeSchool._id, tempActiveSchool)
    //toast(i18n.teachers.teacherSave)
    // let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
    //   this.props.userInformation._id,
    //   this.props.activeSchool._id, 
    //   tempActiveSchool,
    //   i18n.toastMsgs.teacherSave);
    let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
      this.props.userInformation._id,
      this.props.activeSchool._id,
      tempActiveSchool,
      i18n.teachers.teacherSave);

    this.setState({
      showAddNewTeacherComponent: false,
      isSaved: true,
      confirmationDialogTeacher: { isChanged: false },
      teachers: this.attachSearchableStringToTeachers(this.props.activeSchool.school_master.teachers),
    })
    return <TeacherContainer />
  };

  updateTeacherInRules = (teacher, activeSchool) => {
    let schedule_constraints = activeSchool.schedule_constraints
    if (schedule_constraints !== undefined && schedule_constraints.length !== 0) {
      for (let i = 0; i < schedule_constraints.length; i++) {
        let fixedTeachersAndTAsForSubjects = schedule_constraints[i].fixedTeachersAndTAsForSubjects
        if (fixedTeachersAndTAsForSubjects.length !== 0) {
          fixedTeachersAndTAsForSubjects = this.removingTeachersFromFixedTeachersAndTAs(fixedTeachersAndTAsForSubjects, teacher, schedule_constraints[i])
        }

        let fixedTeachersAndTAsForElectives = schedule_constraints[i].fixedTeachersAndTAsForElectives
        if (fixedTeachersAndTAsForElectives.length !== 0) {
          for (let k = 0; k < fixedTeachersAndTAsForElectives.length; k++) {
            let teachersAndTAs = fixedTeachersAndTAsForElectives[k].teachersAndTAs
            teachersAndTAs = this.removingTeachersFromFixedTeachersAndTAs(teachersAndTAs, teacher, schedule_constraints[i])
          }
        }
        if (schedule_constraints[i].isSCheduleUpdated !== undefined && schedule_constraints[i].isSCheduleUpdated === true) {
          schedule_constraints[i].version = schedule_constraints[i].version + 1
        }
      }
    }
  }

  // delete rules if teacher is deleted 
  removingTeachersFromFixedTeachersAndTAs = (fixedTeachersAndTAs, teacher, scheduleObj) => {
    for (let a = 0; a < fixedTeachersAndTAs.length; a++) {
      let teachers = fixedTeachersAndTAs[a].teachers
      let TAs = fixedTeachersAndTAs[a].TAs
      let fixedTeacher = teachers.fixed
      let preferredTeacher = teachers.preferred
      let fixedTAs = TAs.fixed
      let preferredTAs = TAs.preferred

      if (teachers.fixed !== undefined) {
        if (fixedTeacher.length !== 0) {
          let findingSub = lodashUtil.findIndex(fixedTeacher, ["teacherId", teacher.teacherId]);
          if (findingSub !== -1) {
            fixedTeacher.splice(findingSub, 1);
            scheduleObj.isScheduleUpdated = true;
          }
        }
        if (preferredTeacher.length !== 0) {
          let findingSub = lodashUtil.findIndex(preferredTeacher, ["teacherId", teacher.teacherId]);
          if (findingSub !== -1) {
            preferredTeacher.splice(findingSub, 1);
            scheduleObj.isScheduleUpdated = true;
          }
        }
      }
      if (TAs.fixed !== undefined) {
        if (fixedTAs.length !== 0) {
          let findingSub = lodashUtil.findIndex(fixedTAs, ["teacherId", teacher.teacherId]);
          if (findingSub !== -1) {
            fixedTAs.splice(findingSub, 1);
            scheduleObj.isScheduleUpdated = true;
          }
        }
        if (preferredTAs.length !== 0) {
          let findingSub = lodashUtil.findIndex(preferredTAs, ["teacherId", teacher.teacherId]);
          if (findingSub !== -1) {
            preferredTAs.splice(findingSub, 1);
            scheduleObj.isScheduleUpdated = true;
          }
        }
      }

      let fixedTeachersAndTAsForSubjectString = rulesUtil.getFixedTeachersAndTAsForSubject(fixedTeachersAndTAs[a])
      fixedTeachersAndTAs[a].showFixedTeachersForSubjectString = fixedTeachersAndTAsForSubjectString.teachersForSubjectString;
      fixedTeachersAndTAs[a].showFixedTAsForSubjectString = fixedTeachersAndTAsForSubjectString.tAsForSubjectString;
      if (fixedTeacher.length == 0 && preferredTAs.length == 0 && preferredTeacher.length == 0 && fixedTAs.length == 0) {
        fixedTeachersAndTAs.splice(a, 1)
        a -= 1
        scheduleObj.isScheduleUpdated = true;
      }
    }
    return (fixedTeachersAndTAs)
  }
  onClickOfDelete = async (teacher) => {
    const i18n = this.props.i18n;
    let tempActiveSchool = this.props.activeSchool;
    await this.updateTeacherInRules(teacher, tempActiveSchool)
    tempActiveSchool.school_master.teachers.splice(lodashUtil.findIndex(tempActiveSchool.school_master.teachers, { '_id': teacher._id }), 1);
    let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
      this.props.userInformation._id,
      this.props.activeSchool._id,
      tempActiveSchool,
      i18n.teachers.deleteTeacherSuccessToast);

    this.setState({
      teachers: this.attachSearchableStringToTeachers(this.props.activeSchool.school_master.teachers),
    })
  }

  handleOnChange = (name, event) => {
    let tempTeacher = this.state.teacher;
    tempTeacher[name] = event.target.value;
    this.setState({
      toggleChange: !this.state.toggleChange
    })
  };

  filterList = event => {
    var filterBy = lodashUtil.split(event.target.value, ' ')
    var updatedList = this.props.activeSchool.school_master.teachers;
    updatedList = updatedList.filter(function (teacher) {
      let counter = 0;
      for (let i = 0; i < filterBy.length; i++) {
        if (teacher.searchableString.toLowerCase().includes(filterBy[i].toLowerCase())) {
          counter++;
        }
      }
      if (counter == filterBy.length) {
        return true
      } else {
        return false
      }
    });
    this.setState({ teachers: updatedList });
  }
  addNewTeacher = () => {
    const i18n = this.props.i18n
    //let color = theme.colorCatalogue[this.state.teachers.length % theme.colorCatalogue.length]
    //color: color, 
    if (this.props.activeSchool.license.status.toLowerCase() === "active") {
      this.setState({ showAddNewTeacherComponent: true, teacher: { weeklyAvailability: { availableForAllHours: "true" } } })
    } else if (this.props.activeSchool.license.status.toLowerCase() === "trial period") {
      if (this.props.activeSchool.school_master.teachers.length <= this.props.systemConfig.maxNumberOfTeachers) {
        this.setState({ showAddNewTeacherComponent: true, teacher: { weeklyAvailability: { availableForAllHours: "true" } } })
      } else {
        toast(i18n.teachers.maxNumberOfTeachersExceedError)
      }
    } else {
      console.log("Needs to be implimented for other status")
    }

  }
  cancelAddNewTeacher = () => {
    ;
    if (this.state.teachers.length !== this.props.activeSchool.school_master.teachers.length) {
      let tempteachers = this.attachSearchableStringToTeachers(this.props.activeSchool.school_master.teachers)
      this.setState({ showAddNewTeacherComponent: false, teacher: { weeklyAvailability: {} }, teachers: tempteachers })
    }
    else {
      this.setState({ showAddNewTeacherComponent: false, teacher: { weeklyAvailability: {} } })

    }
  }
  editTeacher = (teacher) => {
    this.setState({ showAddNewTeacherComponent: true, teacher: { ...teacher } })
  }
  componentWillMount() {
    const i18n = this.props.i18n
    if (this.props.activeSchool.school_master === undefined) {
      toast(i18n.toastMsgs.noDataInSchoolIndormationMsg)
      this.props.previousStep()
      return
    }
    else if (this.props.activeSchool.school_master.gradeLevels.length === 0) {
      toast(i18n.toastMsgs.noDataInGradeMsg)
      this.props.previousStep(false)
    }
    else {
      let gradeLevelsToBeRendered = { gradeLevels: [...this.props.activeSchool.school_master.gradeLevels] }
      gradeLevelsToBeRendered = gradePickerUtil.constructGradeLevelJSONToBeRendered(gradeLevelsToBeRendered)
      let teachers = this.attachSearchableStringToTeachers(this.props.activeSchool.school_master.teachers)
      let schedule_constraints = JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints))
      this.props.getGradeMasterData();
      this.setState({
        gradeLevelsToBeRendered: gradeLevelsToBeRendered,
        teachers: teachers,
        schedule_constraints: schedule_constraints
      })

    }
  }


  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["teachers"];
    if (content !== undefined) {
      props.toggleDrawer("right", true, content)(event)
    }
  }

  deleteAssignedSubjectFromRules = (deletedSubjectObj, teacher, checkIfSubjecPresent) => {
    let scheduleConstraints = this.state.schedule_constraints
    if (scheduleConstraints.length != 0 && scheduleConstraints !== undefined) {
      for (let i = 0; i < scheduleConstraints.length; i++) {
        let fixedTeachersAndTAsArray = scheduleConstraints[i].fixedTeachersAndTAsForSubjects
        let fixedTeachersAndTAsArrayElectives = scheduleConstraints[i].fixedTeachersAndTAsForElectives
        let numberOfTeachersAndTAsForSubjects = scheduleConstraints[i].numberOfTeachersAndTAsForSubjects
        let numberOfTeachersAndTAsForElectives = scheduleConstraints[i].numberOfTeachersAndTAsForElectives

        let teachersWithSameSubjectId = fixedTeachersAndTAsArray.filter(function (fixedTeachersAndTAsObj) {
          return fixedTeachersAndTAsObj.subjectId === deletedSubjectObj.subjectId
        })

        let numberOfTeachersWithSameSubjectId = numberOfTeachersAndTAsForSubjects.filter(function (numberOfTeachersAndTAsForSubjectObj) {
          return numberOfTeachersAndTAsForSubjectObj.subjectId === deletedSubjectObj.subjectId
        })

        if (checkIfSubjecPresent === "showConfirmDialogForDeletingSuject") {
          if (teachersWithSameSubjectId.length !== 0 || numberOfTeachersWithSameSubjectId.length !== 0) {
            return true
          }
        }

        let numberOfTeacherForElectives = []
        let teachersAndTAsArrayElectives = []
        for (let m = 0; m < numberOfTeachersAndTAsForElectives.length; m++) {
          let teachersAndTAsElectives = numberOfTeachersAndTAsForElectives[m].teachersAndTAs
          numberOfTeacherForElectives = teachersAndTAsElectives.filter(function (teachersAndTAsElectiveObj) {
            return teachersAndTAsElectiveObj.subjectName === deletedSubjectObj.subjectName
          })
        }
        for (let m = 0; m < fixedTeachersAndTAsArrayElectives.length; m++) {
          let fixedTeachersAndTAsElectives = fixedTeachersAndTAsArrayElectives[m].teachersAndTAs
          teachersAndTAsArrayElectives = fixedTeachersAndTAsElectives.filter(function (teachersAndTAsElectivesObj) {
            return teachersAndTAsElectivesObj.subjectName === deletedSubjectObj.subjectName
          })
        }

        if (checkIfSubjecPresent === "showConfirmDialogForDeletingSuject") {
          if (numberOfTeacherForElectives.length !== 0 || teachersAndTAsArrayElectives.length !== 0) {
            return true
          }
        }

        if (teachersWithSameSubjectId.length !== 0) {
          this.removeAssigedSubjcectForTeachersAndTAs(fixedTeachersAndTAsArray, deletedSubjectObj, teacher, scheduleConstraints[i])
        }
        if (numberOfTeachersWithSameSubjectId.length !== 0) {
          this.removeAssigedSubjcectForNumberOfTeachersAndTAs(numberOfTeachersAndTAsForSubjects, deletedSubjectObj, teacher, scheduleConstraints[i])
        }
        if (teachersAndTAsArrayElectives.length !== 0) {
          for (let m = 0; m < fixedTeachersAndTAsArrayElectives.length; m++) {
            let teachersAndTAsForElectives = fixedTeachersAndTAsArrayElectives[m].teachersAndTAs
            this.removeAssigedSubjcectForTeachersAndTAs(teachersAndTAsForElectives, deletedSubjectObj, teacher, teacher, scheduleConstraints[i])
            if (teachersAndTAsForElectives.length === 0) {
              fixedTeachersAndTAsArrayElectives.splice(m, 1)
              m -= 1
              scheduleConstraints[i].isScheduleUpdated = true;
            }
          }
        }
        if (numberOfTeacherForElectives.length !== 0) {
          for (let n = 0; n < numberOfTeachersAndTAsForElectives.length; n++) {
            let teachersAndTAsForElectives = numberOfTeachersAndTAsForElectives[n].teachersAndTAs
            this.removeAssigedSubjcectForNumberOfTeachersAndTAs(teachersAndTAsForElectives, deletedSubjectObj, teacher, scheduleConstraints[i])
            if (teachersAndTAsForElectives.length === 0) {
              numberOfTeachersAndTAsForElectives.splice(n, 1)
              n -= 1
              scheduleConstraints[i].isScheduleUpdated = true;
            }
          }
        }
        if (scheduleConstraints[i].isSCheduleUpdated !== undefined && scheduleConstraints[i].isSCheduleUpdated === true) {
          scheduleConstraints[i].version = scheduleConstraints[i].version + 1
        }
      }
    }
    this.setState({
      schedule_constraints: scheduleConstraints
    })
  }
  removeAssigedSubjcectForTeachersAndTAs = (teachersAndTAsArray, deletedSubjectObj, teacher, scheduleObj) => {
    for (let k = 0; k < teachersAndTAsArray.length; k++) {
      let fixedTeachersAndTAsObj = teachersAndTAsArray[k]
      if (fixedTeachersAndTAsObj.subjectName === deletedSubjectObj.subjectName) {
        teachersAndTAsArray = this.removingTeachersFromFixedTeachersAndTAs(teachersAndTAsArray, teacher, scheduleObj)
      }
    }
  }

  removeAssigedSubjcectForNumberOfTeachersAndTAs = (teachersAndTAsArray, prevSubjectObj, scheduleObj) => {
    for (let k = 0; k < teachersAndTAsArray.length; k++) {
      let fixedTeachersAndTAsObj = teachersAndTAsArray[k]
      if (fixedTeachersAndTAsObj.subjectName === prevSubjectObj.subjectName) {
        teachersAndTAsArray.splice(k, 1)
        k -= 1
        scheduleObj.isScheduleUpdated = true;
      }
    }
  }
  render() {
    return (
      <Fragment>
        <TeacherComponent
          {...this.props}
          {...this.state}
          onClickOfSave={this.onClickOfSave}
          handleOnChange={this.handleOnChange}
          onClickOfNewTeacher={this.onClickOfNewTeacher}
          onClickOfDelete={this.onClickOfDelete}
          filterList={this.filterList}
          addNewTeacher={this.addNewTeacher}
          cancelAddNewTeacher={this.cancelAddNewTeacher}
          editTeacher={this.editTeacher}
          showContextualHelp={this.showContextualHelp}
          deleteAssignedSubjectFromRules={this.deleteAssignedSubjectFromRules}
        />
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
  saveTeacher: (school) => dispatch(TeacherActions.saveTeacher(school)),
  getGradeMasterData: () => dispatch(AddGradeActions.getGradeMasterData()),
  updatedSchoolMaster: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.updatedSchoolMaster(ownerId, schoolId, data))
});

const mapStateToProps = (state, ownProps) => {
  return {
    gradeMasterData: state.gradeInformation.gradeList,
    activeSchool: state.schoolInformation.activeSchool,
    userInformation: state.userProfile.userInformation,
    contextualHelp: state.contextualHelp.contextualHelp.contextualHelp,
    updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(TeacherContainer));
